import { createTheme } from "@mui/material/styles";
import { tokens } from "./tokens";

const c = tokens.color;
const s = tokens.shadow;

// Світла тема платформи — «вишня на кремі»: теплий крем + вишня-oxblood.
const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: c.bg,
      paper: c.surface,
    },
    primary: {
      main: c.gold,
      dark: c.goldDeep,
      light: c.goldLight,
      contrastText: "#ffffff",
    },
    secondary: {
      main: c.olive,
      // Шампань — світлий міжтон: темний текст читається, білий — ні
      contrastText: "#231c0d",
    },
    text: {
      primary: c.ink,
      secondary: c.inkSoft,
    },
    error: { main: c.error },
    success: { main: c.success },
    divider: c.line,
  },
  typography: {
    fontFamily: tokens.font.family,
    fontSize: 14,
    fontWeightMedium: 600,
    h1: { fontWeight: 800, letterSpacing: "-0.02em" },
    h2: { fontWeight: 800, letterSpacing: "-0.02em" },
    h3: { fontWeight: 800, letterSpacing: "-0.015em" },
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h5: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: { fontWeight: 600, letterSpacing: "0.01em" },
  },
  shape: { borderRadius: tokens.radius.lg },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: c.bg },
        "::selection": { background: "rgba(108,17,41,0.14)" },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          backgroundImage: `linear-gradient(90deg, ${c.dark} 0%, #2e1d17 100%)`,
          color: c.onDark,
          border: "none",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          borderRadius: 0, // не наслідувати радіус MuiPaper
          boxShadow: s.header,
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 600,
          transition: "transform .15s ease, box-shadow .15s ease, background-color .15s ease, border-color .15s ease",
        },
        contained: {
          boxShadow: s.soft,
          "&:hover": { boxShadow: s.card, transform: "translateY(-1px)" },
        },
        outlined: {
          "&:hover": { transform: "translateY(-1px)" },
        },
        sizeLarge: { paddingBlock: 10, paddingInline: 26, fontSize: "1rem" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: c.surface,
          border: `1px solid ${c.line}`,
          borderRadius: tokens.radius.lg,
        },
        // Підняті картки (Paper elevation ≥1) — тінь замість рамки.
        elevation1: { boxShadow: s.card, border: "none" },
        elevation2: { boxShadow: s.card, border: "none" },
        elevation3: { boxShadow: s.card, border: "none" },
        elevation4: { boxShadow: s.card, border: "none" },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: s.card, border: "none", borderRadius: tokens.radius.lg },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: c.line },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: c.lineStrong },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: c.gold, height: 3, borderRadius: 3 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500, borderRadius: 8 },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: { "& .MuiTableCell-root": { fontWeight: 700, color: c.inkSoft } },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { borderRadius: 8, fontSize: "0.75rem", backgroundColor: c.dark },
      },
    },
  },
});

export default theme;
